import axios from 'axios';
import furball from 'wa-furball';
import { fetchAllData } from '../../../utils';
import { Mechanic } from '../../StateContext';
import { Project } from '../../StateContext';
import { User } from '../../StateContext';
import { Urls } from '../../../Urls';

export const loginCall = (userName, password, setLoginData) => {
    const t0 = performance.now();
    const url = `${Urls.BaseApiUrl}/Auth`;
    console.debug('[loginCall] POST', url, '| user:', userName);
    return axios
        .post(url, {
            username: userName,
            password: password,
        })
        .then((response) => {
            console.debug(`[loginCall] success in ${(performance.now() - t0).toFixed(0)}ms | user:`, response.data.user?.userName);
            furball.success(`${response.data.user.userName} is ingelogd.`);
            setLoginData(response.data);
        })
        .catch((error) => {
            const ms = (performance.now() - t0).toFixed(0);
            console.error(`[loginCall] FAILED after ${ms}ms`);
            console.error('  URL:', url);
            console.error('  Status:', error.response?.status ?? 'no response (CORS/network)');
            console.error('  Headers sent:', error.config?.headers);
            console.error('  Response data:', error.response?.data ?? '(no response body)');
            console.error('  Message:', error.message);
            furball.error('Inloggen mislukt.');
        });
};

export const CheckIfAlreadyLoggedIn = (setLoginData, onDone?: () => void) => {
    const t0 = performance.now();
    const url = `${Urls.BaseApiUrl}/Auth`;
    console.debug('[CheckIfAlreadyLoggedIn] GET', url);
    return axios
        .get(url)
        .then((response) => {
            console.debug(`[CheckIfAlreadyLoggedIn] session active in ${(performance.now() - t0).toFixed(0)}ms | user:`, response.data.user?.userName);
            furball.success(`${response.data.user.userName} is ingelogd.`);
            setLoginData(response.data);
        })
        .catch((error) => {
            const ms = (performance.now() - t0).toFixed(0);
            console.warn(`[CheckIfAlreadyLoggedIn] no session after ${ms}ms`);
            console.warn('  Status:', error.response?.status ?? 'no response (CORS/network)');
            console.warn('  Message:', error.message);
        })
        .finally(() => {
            onDone?.();
        });
};

export const addMechanicCall = (mechanicName, about, type, defaultWeight, setLoginData) => {
    axios
        .post(`${Urls.BaseApiUrl}/Mechanic`, {
            name: mechanicName,
            about: about,
            type: parseInt(type as string),
            defaultWeight: defaultWeight,
        })
        .then((response) => {
            furball.success(`${response.data.name} is toegevoegd.`);
            fetchAllData(setLoginData);
        })
        .catch((error) => {
            furball.error('Toevoegen mislukt.');
        });
};

export const editMechanicCall = (
    id,
    mechanicName,
    about,
    type,
    setLoginData
) => {
    axios
        .put(`${Urls.BaseApiUrl}/Mechanic/${id}`, {
            name: mechanicName,
            about: about,
            type: type,
        })
        .then((response) => {
            furball.success(`${response.data.name} is gewijzigd.`);
            fetchAllData(setLoginData);
        })
        .catch((error) => {
            furball.error('Wijzgen mislukt.');
        });
};

export const editWeekDataCall = (
    id,
    weekId,
    secondsWorked,
    weekNumber,
    hourWeight,
    year,
    setLoginData,
    projectTypeId?: number | null
) => {
    axios
        .put(`${Urls.BaseApiUrl}/links/${id}/week/${weekId}`, {
            secondsWorked: secondsWorked,
            weekNumber: weekNumber,
            weight: hourWeight,
            year: year,
            projectTypeId: projectTypeId ?? null,
        })
        .then((response) => {
            furball.success(`Week ${weekNumber} is gewijzigd.`);
            fetchAllData(setLoginData);
        })
        .catch((error) => {
            furball.error('Wijzgen mislukt.');
        });
};

export const editLinkWeightCall = (
    linkId: number,
    weight: number,
    setLoginData
) => {
    axios
        .put(`${Urls.BaseApiUrl}/links/${linkId}/weight`, {
            weight: weight,
        })
        .then(() => {
            furball.success('Percentage voor alle weken is gewijzigd.');
            fetchAllData(setLoginData);
        })
        .catch((error) => {
            furball.error('Wijzgen mislukt.');
        });
};

export const updateProjectExtrasCall = (
    projectId: number,
    meerwerkSeconds: number,
    dhzSeconds: number,
    setLoginData
) => {
    axios
        .put(`${Urls.BaseApiUrl}/Project/${projectId}/extras`, {
            meerwerkSeconds,
            dhzSeconds,
        })
        .then(() => {
            fetchAllData(setLoginData);
        })
        .catch(() => {
            furball.error('Opslaan mislukt.');
        });
};

export const connectMechanicCall = (projectId, mechanicId, setLoginData, t, typeId?: number | null) => {
    const url = typeId
        ? `${Urls.BaseApiUrl}/links/${projectId}/${mechanicId}?typeId=${typeId}`
        : `${Urls.BaseApiUrl}/links/${projectId}/${mechanicId}`;
    axios
        .post(url)
        .then((response) => {
            furball.success(`Monteur is gekoppeld.`);
            fetchAllData(setLoginData);
        })
        .catch((error) => {
            const status = error.response?.status;
            if (status === 409 || status === 500) {
                furball.error(t('mechanicAlreadyConnected'));
            } else if (status === 404) {
                furball.error(t('connectNotFound'));
            } else if (status === 403) {
                furball.error(t('connectForbidden'));
            } else if (!error.response) {
                furball.error(t('connectNetworkError'));
            } else {
                furball.error(t('connectFailed'));
            }
        });
};

export const deleteLink = (linkId, setLoginData) => {
    axios
        .delete(`${Urls.BaseApiUrl}/links/${linkId}`)
        .then(() => {
            furball.success(`Koppeling is verwijderd.`);
            fetchAllData(setLoginData);
        })
        .catch((error) => {
            furball.error('Verwijderen mislukt.');
        });
};

export const addToDoListCall = (projectId, title, setLoginData) => {
    axios
        .post(`${Urls.BaseApiUrl}/project/${projectId}`, {
            title: title,
            projectId: projectId,
        })
        .then(() => {
            furball.success(`Punt is toegevoegd.`);
            fetchAllData(setLoginData);
        })
        .catch((error) => {
            furball.error('Toevoegen mislukt.');
        });
};

export const EditToDoCall = (toDoId, title, setLoginData) => {
    axios
        .post(`${Urls.BaseApiUrl}/project/${toDoId}`, {
            title: title,
            toDoId: toDoId,
        })
        .then(() => {
            furball.success(`Punt is gewijzigd.`);
            fetchAllData(setLoginData);
        })
        .catch((error) => {
            furball.error('Wijzigen mislukt.');
        });
};

export const deleteToDoCall = (toDoId, setLoginData) => {
    axios
        .delete(`${Urls.BaseApiUrl}/project/${toDoId}`)
        .then(() => {
            furball.success(`Punt is verwijderd.`);
            fetchAllData(setLoginData);
        })
        .catch((error) => {
            furball.error('Verwijderen mislukt.');
        });
};

export const addProjectCall = (
    projectName,
    description,
    estimatedTimeInSeconds,
    setLoginData,
    materialsDelivered = false,
    types: { name: string; calculatedTimeInSeconds: number }[] = []
) => {
    axios
        .post(`${Urls.BaseApiUrl}/Project`, {
            name: projectName,
            about: description,
            estimatedTimeInSeconds: estimatedTimeInSeconds,
            materialsDelivered: materialsDelivered,
            types: types,
        })
        .then((response) => {
            furball.success(`${response.data.name} is toegevoegd.`);
            fetchAllData(setLoginData);
        })
        .catch((error) => {
            furball.error('Toevoegen mislukt.');
        });
};

export const addWeekCall = (
    linkId,
    weekNumber,
    secondsWorked,
    hourWeight,
    year,
    setLoginData,
    projectTypeId?: number | null
) => {
    axios
        .post(`${Urls.BaseApiUrl}/links/${linkId}/week/${weekNumber}`, {
            secondsWorked: secondsWorked,
            weight: hourWeight,
            year: year,
            projectTypeId: projectTypeId ?? null,
        })
        .then((response) => {
            furball.success(`Week ${weekNumber} is toegevoegd.`);
            fetchAllData(setLoginData);
        })
        .catch((error) => {
            furball.error('Toevoegen mislukt.');
        });
};

export const editProjectCall = (
    id,
    projectName,
    estimatedTimeInSeconds,
    description,
    setLoginData,
    materialsDelivered = false
) => {
    axios
        .put(`${Urls.BaseApiUrl}/Project/${id}`, {
            name: projectName,
            estimatedTimeInSeconds: estimatedTimeInSeconds,
            about: description,
            materialsDelivered: materialsDelivered,
        })
        .then((response) => {
            furball.success(`${response.data.name} is gewijzigd.`);
            fetchAllData(setLoginData);
        })
        .catch((error) => {
            furball.error('Wijzigen mislukt.');
        });
};

export const deleteMechanicCall = (m: Mechanic, setLoginData) => {
    axios
        .delete(`${Urls.BaseApiUrl}/Mechanic/${m.id}`)
        .then(() => {
            furball.success(`${m.name} is verwijderd.`);
            fetchAllData(setLoginData);
        })
        .catch((error) => {
            furball.error('Verwijderen mislukt.');
        });
};

export const deleteProjectCall = (p: Project, setLoginData) => {
    axios
        .delete(`${Urls.BaseApiUrl}/Project/${p.id}`)
        .then(() => {
            furball.success(`${p.name} is verwijderd.`);
            fetchAllData(setLoginData);
        })
        .catch((error) => {
            furball.error('Verwijderen mislukt.');
        });
};

export const logoutCall = (userName) => {
    axios.post(`${Urls.BaseApiUrl}/Auth/logout`);
    furball.info(`${userName} is uitgelogd`);
};

export const getAdminUsersCall = async (): Promise<User[]> => {
    const response = await axios.get(`${Urls.BaseApiUrl}/Admin/users`);
    return response.data;
};

export const editAdminUserCall = (userId: string, userName: string, isAdmin: boolean, onSuccess: () => void) => {
    axios
        .put(`${Urls.BaseApiUrl}/Admin/users/${userId}`, { userName, isAdmin })
        .then(() => {
            furball.success('Gebruiker bijgewerkt.');
            onSuccess();
        })
        .catch(() => furball.error('Bijwerken mislukt.'));
};

export const unlockAdminUserCall = (userId: string, onSuccess: () => void) => {
    axios
        .post(`${Urls.BaseApiUrl}/Admin/users/${userId}/unlock`)
        .then(() => {
            furball.success('Account ontgrendeld.');
            onSuccess();
        })
        .catch(() => furball.error('Ontgrendelen mislukt.'));
};

export const deleteAdminUserCall = (userId: string, onSuccess: () => void) => {
    axios
        .delete(`${Urls.BaseApiUrl}/Admin/users/${userId}`)
        .then(() => {
            furball.success('Gebruiker verwijderd.');
            onSuccess();
        })
        .catch(() => furball.error('Verwijderen mislukt.'));
};

export const addProjectTypeRaw = (projectId: number, name: string, calculatedTimeInSeconds: number = 0) =>
    axios.post(`${Urls.BaseApiUrl}/Project/${projectId}/types`, { name, calculatedTimeInSeconds });

export const updateProjectTypeRaw = (projectId: number, typeId: number, name: string, calculatedTimeInSeconds: number) =>
    axios.put(`${Urls.BaseApiUrl}/Project/${projectId}/types/${typeId}`, { name, calculatedTimeInSeconds });

export const deleteProjectTypeRaw = (projectId: number, typeId: number) =>
    axios.delete(`${Urls.BaseApiUrl}/Project/${projectId}/types/${typeId}`);

export const addProjectNoteCall = (projectId: number, content: string, setLoginData) => {
    axios
        .post(`${Urls.BaseApiUrl}/Project/${projectId}/notes`, { content })
        .then(() => fetchAllData(setLoginData))
        .catch(() => furball.error('Notitie toevoegen mislukt.'));
};

export const updateProjectNoteCall = (projectId: number, noteId: number, content: string, setLoginData) => {
    axios
        .put(`${Urls.BaseApiUrl}/Project/${projectId}/notes/${noteId}`, { content })
        .then(() => fetchAllData(setLoginData))
        .catch(() => furball.error('Notitie wijzigen mislukt.'));
};

export const deleteProjectNoteCall = (projectId: number, noteId: number, setLoginData) => {
    axios
        .delete(`${Urls.BaseApiUrl}/Project/${projectId}/notes/${noteId}`)
        .then(() => fetchAllData(setLoginData))
        .catch(() => furball.error('Notitie verwijderen mislukt.'));
};

export const registerUserCall = (userName, password, registrationCode, setLoginData) => {
    return axios
        .post(`${Urls.BaseApiUrl}/Auth/create`, {
            username: userName,
            password: password,
            registrationCode: registrationCode,
        })
        .then((response) => {
            furball.success(`${response.data.user.userName} is aangemaakt.`);
            setLoginData(response.data);
        })
        .catch((error) => {
            const status = error.response?.status;
            const data = error.response?.data;
            if (status === 400 && data === 'InvalidCode') {
                furball.error('Ongeldige registratiecode.');
            } else if (status === 409) {
                furball.error('Gebruikersnaam is al in gebruik.');
            } else {
                furball.error('Registreren mislukt.');
            }
        });
};
